import React from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Table, Badge } from "reactstrap";
import { AuditSummary } from "store/audits/types";

interface Props {
	summaries: AuditSummary[];
	t?: any;
}

const AuditSummaryTable: React.FC<Props> = ({ summaries, t }) => {
	const formatDate = (dateStr: string) =>
		new Date(dateStr).toLocaleDateString("en-GB");

	return (
		<div className="mb-5 d-flex flex-column gap-1">
			<h5 className="fw-semibold">{t("footprints.activities")}</h5>

			{summaries.length === 0 ? (
				<div className="text-center p-5 border rounded bg-light">
					<i className="ri-file-info-line fs-2 text-muted mb-2 d-block" />
					<h6 className="fw-semibold text-muted">{t("footprints.no_activity_summary_found")}</h6>
					<p className="text-muted small mb-0">
						{t("footprints.there_are_no_audit_summary_available_selected_filters_date")}
					</p>
				</div>
			) : (
				<div className="table-responsive border rounded shadow-sm">
					<Table className="align-middle table-nowrap mb-0">
						<thead className="table-light">
							<tr>
								<th style={{ width: "10%" }}>Date</th>
								<th style={{ width: "15%" }}>User</th>
								<th style={{ width: "15%" }}>Role</th>
								<th style={{ width: "10%" }}>Check-in</th>
								<th style={{ width: "10%" }}>Check-out</th>
								<th style={{ width: "20%" }}>Remarks</th>
								<th style={{ width: "5%" }}>Points</th>
								<th style={{ width: "5%" }}>Leads</th>
								<th style={{ width: "5%" }}>Activities</th>
							</tr>
						</thead>
						<tbody>
							{summaries.map((summary, idx) => (
								<tr key={idx}>
									<td>{formatDate(summary.date)}</td>
									<td>
										<Link
											to={`/footprints/${summary.user.id}?date=${summary.date}`}
											className="link-primary fw-semibold text-decoration-none link-underline-hover"
											title="Click to view detailed activity"
										>
											{summary.user.name}
										</Link>
									</td>
									<td>{summary.role?.name || "–"}</td>
									<td>{summary.check_in_time || "–"}</td>
									<td>{summary.check_out_time || "–"}</td>
									<td>
										{summary.remarks.length > 0 ? (
											summary.remarks.map((r, i) => (
												<div key={i} className="text-muted small d-flex align-items-start">
													<i className="ri-alert-fill text-warning me-1" />
													<span>{r}</span>
												</div>
											))
										) : (
											"–"
										)}
									</td>
									<td>
										<Badge color={summary.points ? "success" : "secondary"}>
											{summary.points ?? "–"}
										</Badge>
									</td>
									<td>
										<Badge color={summary.leads ? "info" : "secondary"}>
											{summary.leads ?? "–"}
										</Badge>
									</td>
									<td>
										<Badge color={summary.activities ? "primary" : "secondary"}>
											{summary.activities ?? "–"}
										</Badge>
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			)}
		</div>
	);
};

export default withTranslation()(AuditSummaryTable);
